import { render } from "./HistoryColumn.vue?vue&type=template&id=23b245b1&scoped=true"
import script from "./HistoryColumn.vue?vue&type=script&lang=js"
export * from "./HistoryColumn.vue?vue&type=script&lang=js"

import "./HistoryColumn.vue?vue&type=style&index=0&id=23b245b1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b245b1"]])

export default __exports__